module.exports = __webpack_public_path__ + "img/0_0.9d56fdb0.png";